import { gql } from "@apollo/client";
import {
  FEED_CURVE_FRAGMENT,
  FeedCurve,
} from "../../FeedDataCalls/GQLCalls/getFeedCurvesCall";
import { MilestoneInfo } from "../../MilestoneDataCalls/GQLCalls/getMilestonesCall";

export const PANEL_ANIMAL_FRAGMENT = gql`
  fragment AnimalFields on PanelAnimalInfo {
    animal_id
    location_id
    animal_number
    cycle
    correction
    feedcurves_id
    feedcurve_milestones
    milestone_day
    condition
    animal_type
    responder_number
    life_number
    birthday
    animalGroup {
      groupId
      name
    }
    milestone {
      name
      milestone_id
    }
    consumptions(domain: $domain) @skip(if: $ifSkipConsumption) {
      consumed
      dayTotal
      milestoneDayOffset
    }
    consumptions(
      domain: $domain
      amountOfDays: 10
      milestoneDayOffset: 0
    ) @skip(if: $ifSkipLastTenDaysConsumption) {
      consumed
      dayTotal
      milestoneDayOffset
    }
    feedCurve(domain: $domain) {
      ...FeedCurveFields
    }
    system(domain: $domain)
    event(domain: $domain) {
      timestamp
      eventNo: animal_event_id
      eventName: event_name
      note
    }
  }
  ${FEED_CURVE_FRAGMENT}
`;

export const GET_ANIMALS_INFO = gql`
  query GetAnimalInfo(
    $domain: String!
    $input: PanelBasicQueryInfoInput!
    $idIdentifier: String
    $ifFeedCurveBaseInfoOnly: Boolean!
    $ifFeedCurveInfo: Boolean!
    $ifSpreading: Boolean!
    $ifSkipConsumption: Boolean!
    $ifSkipLastTenDaysConsumption: Boolean!
  ) {
    animal {
      info(domain: $domain, input: $input, idIdentifier: $idIdentifier) {
        ...AnimalFields
      }
    }
  }
  ${PANEL_ANIMAL_FRAGMENT}
`;

export type AnimalInfo = {
  animal_id: number;
  location_id?: number;
  animal_number: number;
  cycle: number;
  correction?: number;
  feedcurves_id?: number;
  feedcurve_milestone?: number;
  milestone_day?: number;
  condition?: number;
  animal_type?: number;
  responder_number?: number;
  life_number?: number;
  birthday?: number;
  animalGroup: {
    groupId?: number;
    name?: string;
  };
  consumptions?: Consumption[];
  lastTenDay?: Consumption[];
  milestone?: Omit<MilestoneInfo, "deleted">;
  feedCurve?: FeedCurve;
  system?: string;
  event?: AnimalEvent[]
};

interface AnimalEvent {
  timestamp: string
  eventNo: number
  eventName: string
  note?: string
}

export interface Consumption {
  progressed?: number;
  total?: number;
  milestoneDayOffset?: number;
}

export interface AnimalResponse {
  animal: {
    info: AnimalInfo[];
  }
}
